import PassportStudentInfo from "./PassportStudentInfo";

export default PassportStudentInfo;